import React from 'react';
import { Link } from 'react-router-dom';
import './DeleteAccount.css'; // Reusing styles for consistency

const AccountConfirmed = () => {
    return (
        <div className="delete-container">
            <div className="card" style={{ textAlign: 'center' }}>
                <div style={{ fontSize: '4rem', marginBottom: '1.5rem' }}>✅</div>
                <h2>Conta Confirmada!</h2>
                <p>
                    Sua conta foi verificada com sucesso. Agora você já pode aproveitar 
                    todos os recursos do SeandMe diretamente no nosso aplicativo.
                </p>
                <Link to="/" className="primary-button" style={{ textDecoration: 'none', display: 'block' }}>
                    Voltar ao Início
                </Link>
            </div>
        </div>
    );
};

export default AccountConfirmed;
